module.exports = __webpack_public_path__ + "static/media/BikeSharing-retro3.a190f3c2.pdf";